import { render } from "./codeLogin.vue?vue&type=template&id=10f0664e&scoped=true"
import script from "./codeLogin.vue?vue&type=script&lang=js"
export * from "./codeLogin.vue?vue&type=script&lang=js"

import "./codeLogin.vue?vue&type=style&index=0&id=10f0664e&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f0664e"]])

export default __exports__